import { MatDialog } from '@angular/material';
import { ViewQrCodeModalComponent } from './view-qr-code-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
var ViewQrCodeModalService = /** @class */ (function () {
    function ViewQrCodeModalService(matDialog) {
        this.matDialog = matDialog;
    }
    ViewQrCodeModalService.prototype.open = function (_a) {
        var qrCode = _a.qrCode, fileName = _a.fileName;
        return this.matDialog.open(ViewQrCodeModalComponent, {
            data: { qrCode: qrCode, fileName: fileName }
        }).afterClosed()
            .toPromise();
    };
    ViewQrCodeModalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ViewQrCodeModalService_Factory() { return new ViewQrCodeModalService(i0.ɵɵinject(i1.MatDialog)); }, token: ViewQrCodeModalService, providedIn: "root" });
    return ViewQrCodeModalService;
}());
export { ViewQrCodeModalService };
